import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { get, set, del, createStore } from 'idb-keyval';

// Create IndexedDB store for React Query cache
const idbStore = createStore('reactor-cache', 'cache');

// Create async storage adapter for idb-keyval
const idbStorage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      const value = await get<string>(key, idbStore);
      if (value) {
        console.log('[Persister] Retrieved from IndexedDB:', key.substring(0, 50));
      }
      return value ?? null;
    } catch (error) {
      console.error('[Persister] Error reading from IndexedDB:', error);
      return null;
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      await set(key, value, idbStore);
      console.log('[Persister] Saved to IndexedDB:', key.substring(0, 50), 'size:', value.length);
    } catch (error) {
      console.error('[Persister] Error writing to IndexedDB:', error);
    }
  },
  removeItem: async (key: string): Promise<void> => {
    try {
      await del(key, idbStore);
      console.log('[Persister] Removed from IndexedDB:', key.substring(0, 50));
    } catch (error) {
      console.error('[Persister] Error removing from IndexedDB:', error);
    }
  },
};

export const persister = createAsyncStoragePersister({
  storage: idbStorage,
});

